import styled from 'styled-components';
import imageBackground from '../images/background.png';
import DescriptionImg from '../images/description.jpg';

import { device } from '../components/theme/devices';

export const HeroContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-top: 30px;
  flex-wrap: wrap-reverse;
  padding: 20px 0;
  height: 180px;

  @media ${device.mobile} {
    display: none;
  }

  p {
    /* background-color: #1d75a1; */
    width: 60%;
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 28px;
    line-height: 38px;
    color: #e5e5e5;
    text-align: center;
    margin-bottom: 80px;

    @media ${device.mobile} {
      display: none;
    }
  }

  div {
    width: 450px;
    height: auto;
    @media ${device.mobile} {
      text-align: center;
    }
  }
`;

export const TopSection = styled.section`
  flex: 1;
  background: url(${imageBackground}) no-repeat center;
  background-size: cover;
  background-position: center top;
  @media ${device.mobile} {
    background-size: unset;
  }
`;

export const MiddleSection = styled.section`
  flex: 1;
  background: url(${DescriptionImg}) no-repeat center;
  background-size: cover;
  background-position: center top;

  height: 300px;

  p {
    font-family: Roboto;
    font-style: bold;
    font-weight: 400;
    font-size: 18px;
    line-height: 28px;

    display: flex;
    align-items: center;
    text-align: center;

    color: #ffffff;
    background-color: rgb(10, 15, 35, 0.8);
  }
`;

export const FooterContainer = styled.div`
  width: 80%;
  height: auto;
  display: flex;
  flex-direction: row;
  padding: 20px;
  justify-content: space-evenly;
  flex-wrap: wrap;

  @media ${device.mobile} {
    justify-content: flex-start;
    padding: 0px;
  }

  div {
    @media ${device.mobile} {
      display: flex;
      flex-direction: column;
    }
  }

  h2 {
    color: #ffffff;
    font-family: Roboto;
    font-style: normal;
    font-weight: 900;
    font-size: 18px;
    line-height: 30px;
    display: flex;
    align-items: center;
  }

  p,
  a {
    font-family: Roboto;
    font-style: normal;
    font-weight: 300;
    font-size: 18px;
    line-height: 10px;

    display: flex;
    align-items: center;
    text-align: center;

    color: #ffffff;

    text-decoration: none;
  }

  svg {
    margin-right: 10px;
    :hover {
      width: 26px;
      height: 26px;
    }
  }
`;
